
<div class="modal-custom">
  <div class="modal-header">
    <h4 class="modal-title"><span class="ml-2">More Details</span></h4>
    <button type="button" class="close" data-dismiss="modal" (click)="close()">×</button>
  </div>


  <div class="modal-body">
    <div class="mt-2">
      <div>
        <label class="font-weight-bold">Sub Transaction : </label>
        <span class="ml-2">{{productName}}</span>
      </div>
      <div>
        <label class="font-weight-bold">Status : </label>
        <span class="ml-2 {{getStatusIconClassName(status)}}"></span><span class="ml-2 {{getStatusTextClassName(status)}}">{{status}}</span>
      </div>
      <div>
        <label class="font-weight-bold">Error Description : </label>
        <span class="ml-2">{{statusDescription}}</span>
      </div>

    </div>
  </div>
  <div class="modal-footer mt-4">
    <button type="button" class="btn btn-primary" data-dismiss="modal" (click)="close()">Okay</button>
  </div>
</div>





